import React from "react";
import { FaWhatsapp } from "react-icons/fa";
import "../css/WhatsAppButton.css";

const WhatsAppButton = () => {
  const phoneNumber = "+351962281179";
  const message =
    "Olá, entrei no site de vocês e gostaria de agendar a minha avaliação.";
  const encodedMessage = encodeURIComponent(message);
  const whatsappURL = `https://wa.me/${phoneNumber.replace(/\s/g, "")}?text=${encodedMessage}`;

  return (
    <a
      href={whatsappURL}
      target="_blank"
      rel="noopener noreferrer"
      className="whatsapp-button"
      aria-label="Contact us on WhatsApp"
    >
      <FaWhatsapp className="whatsapp-icon" />
    </a>
  );
};

export default WhatsAppButton;
